import { render, staticRenderFns } from "./NumberArrows.vue?vue&type=template&id=575103d0"
import script from "./NumberArrows.vue?vue&type=script&lang=js"
export * from "./NumberArrows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports